import { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import ParityManagerFiltersMarketInfo from 'lumen/models/parity-manager/filters/market-info';

export default class ParityManagerFiltersAssignee extends ParityManagerFiltersMarketInfo {
  // @ts-expect-error: Class inheritance
  [Type] = 'parity-manager/filters/assignee' as const;

  @attr('string') declare name: string;

  get formattedName(): string {
    return this.name.toLowerCase();
  }
}
